import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { tokenText } from './tokenText';
import './roleTokens.css';

export default function PromotionChoiceModal({ infoSource, show, onClose, onSelect }) {
  const t = tokenText(infoSource);
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      restoreFocus
      contentClassName="promotion-choice-modal"
      aria-labelledby="promotion-choice-title"
    >
      <Modal.Header closeButton closeLabel={t('closePromotionChoice')}>
        <Modal.Title id="promotion-choice-title">{t('promotionChoiceTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('promotionChoiceDescription')}</p>
        <div className="promotion-choice-actions">
          <button type="button" className="btn btn-primary" onClick={() => onSelect('Seller')}>
            {t('becomeSeller')}
          </button>
          <button type="button" className="btn btn-outline-primary" onClick={() => onSelect('Provider')}>
            {t('becomeProvider')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
